import React, { useState } from "react";
import "./useragentmodal.css";
import { Modal } from "react-bootstrap";
import { DatePicker, message, Select } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import  Instance from "../../../AxiosConfig";

const UserAddAgentModal = ({ show, handleClose,fetchUsers }) => {
  const [formData, setFormData] = useState({
    userName: "",
    userEmail: "",
    userPassword: "",
    userPhoneNumber: "",
    role: "",
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  // ✅ Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Validation function
  const validate = () => {
    let newErrors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordPattern =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

    if (!formData.userName.trim()) newErrors.userName = "Name is required.";
    if (!emailPattern.test(formData.userEmail))
      newErrors.userEmail = "Enter a valid email.";
    if (!passwordPattern.test(formData.userPassword))
      newErrors.userPassword =
        "Password must include uppercase, lowercase, number, and special character.";
    if (!formData.userPhoneNumber.trim())
      newErrors.userPhoneNumber = "Phone number is required.";
    if (!formData.role) newErrors.role = "Role is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await Instance.post("/users/", formData);
      if (response.status === 200 || response.status === 201) {
        message.success("New user added successfully!");
        handleClose();
        fetchUsers();
        setFormData({
          userName: "",
          userEmail: "",
          userPassword: "",
          userPhoneNumber: "",
          role: "",
        });
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || "Failed to add user. Try again."
      );
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Add New User</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="container-fluid">
            {/* Row 1 */}
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="userName"
                  value={formData.userName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter full name"
                />
                {errors.userName && (
                  <small className="text-danger">{errors.userName}</small>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="userEmail"
                  value={formData.userEmail}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="example@gmail.com"
                />
                {errors.userEmail && (
                  <small className="text-danger">{errors.userEmail}</small>
                )}
              </div>
            </div>

            {/* Row 2 */}
            <div className="row mb-4">
              <div className="col-md-6 position-relative">
                <label className="form-label">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="userPassword"
                  value={formData.userPassword}
                  onChange={handleChange}
                  className="form-control pe-5"
                  placeholder="Enter strong password"
                />
                <span
                  className="password-toggle-icon"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "38px",
                    cursor: "pointer",
                    color: "#888",
                  }}
                >
                  {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </span>
                {errors.userPassword && (
                  <small className="text-danger">{errors.userPassword}</small>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <PhoneInput
                  defaultCountry="in"
                  value={formData.userPhoneNumber}
                  onChange={(phone) =>
                    setFormData({ ...formData, userPhoneNumber: phone })
                  }
                  className="w-100"
                  placeholder="Enter phone number"
                />
                {errors.userPhoneNumber && (
                  <small className="text-danger">{errors.userPhoneNumber}</small>
                )}
              </div>
            </div>

            {/* Row 3 */}
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-label">Role</label>
                <Select
                  placeholder="Select Role"
                  value={formData.role || undefined}
                  onChange={(value) => setFormData({ ...formData, role: value })}
                  style={{ width: "100%" }}
                  options={[
                    { label: "Admin", value: "admin" },
                    { label: "Editor", value: "editor" },
                  ]}
                />
                {errors.role && (
                  <small className="text-danger">{errors.role}</small>
                )}
              </div>

            
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="users-discard-button"
                onClick={handleClose}
              >
                Discard
              </button>
              <button type="submit" className="users-save-button">
                Save
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default UserAddAgentModal;
